/**
 * A touch button (spec 2p §4). onPress fires when the finger lifts over the button, so sliding off cancels;
 * onDown fires at once (jump, ⟲ ⟳) and repeats every repeatMs while held. pointerdown's default is prevented:
 * that stops the compatibility mousedown, so a focused chat input keeps its focus (Review Focus 3).
 */
/** The release of every button held right now. */
const held = new Set<() => void>();

/** Let go of every held button without pressing it: the phone turned, so no finger is where it was. */
export function releaseAllPressed(): void {
  for (const release of [...held]) release();
}

export function pressable(el: HTMLElement, opts: { onPress?: () => void; onDown?: () => void; onUp?: () => void; repeatMs?: number }): void {
  let id: number | null = null;
  let timer: ReturnType<typeof setInterval> | null = null;
  const release = () => {
    held.delete(release);
    if (timer) clearInterval(timer);
    timer = null;
    id = null;
    el.classList.remove("down");
    opts.onUp?.();
  };
  el.addEventListener("pointerdown", (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (id !== null) return;
    id = e.pointerId;
    el.classList.add("down");
    held.add(release);
    try { el.setPointerCapture?.(e.pointerId); } catch { /* not every pointer can be captured */ }
    opts.onDown?.();
    if (opts.repeatMs && opts.onDown) timer = setInterval(opts.onDown, opts.repeatMs);
  });
  el.addEventListener("pointerup", (e) => {
    if (e.pointerId !== id) return;
    const r = el.getBoundingClientRect();
    const inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
    release();
    if (inside) opts.onPress?.();
  });
  el.addEventListener("pointercancel", (e) => { if (e.pointerId === id) release(); });
}
